"use client"

import { motion } from "framer-motion"
import { Banner } from "../banner"

const tags = [
  "Future Business",
  "Collaborate",
  "Building Bridges",
  "Opportunities"
]

export function AboutUsForm() {
  return (
    <>
      <Banner page={'About'} heading={'About Interpetro Chemicals'} image={"/images/slider.jpg"} />
      <section className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="flex-col lg:flex-row flex gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="relative lg:w-2/4 w-full"
            >
              <div className="relative rounded-2xl overflow-hidden h-80 lg:h-[600px]">
                <img
                  src="/images/minimalist-construction-pvc-pipes-arrangement.png"
                  alt="Medical Professional"
                  className="object-cover w-full h-full"
                />
              </div>

              <div
                className="absolute -bottom-8 -right-6 w-60 h-52 rounded-xl overflow-hidden hidden md:block border-white border-[16px]"
              >
                <img
                  src="/images/problem-solve1.jpg"
                  alt="Medical Conference"
                  className="object-cover w-full h-full rounded-xl"
                />
              </div>
            </motion.div>

            {/* Right Column - Content */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="space-y-6 relative lg:w-2/4 w-full"
            >
              <div className="mb-8 md:mb-12">
                <motion.span
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className="text-blue-600 font-medium block mb-4"
                >
                  BUSINESS CONFERENCE
                </motion.span>
                <motion.h2
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 }}
                  className="text-4xl md:text-5xl font-bold leading-none"
                >
                  Problem-Solving
                  <br />
                  Business Conference.
                </motion.h2>
              </div>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
                className="flex flex-wrap gap-2"
              >
                {tags.map((tag, index) => (
                  <motion.span
                    key={tag}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.7 + index * 0.1 }}
                    className="px-4 py-2 bg-gray-100 rounded-full text-sm font-medium hover:bg-gray-200 transition-colors"
                  >
                    {tag}
                  </motion.span>
                ))}
              </motion.div>

              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.8 }}
                className="text-gray-600 text-lg"
              >
                Interpetro Chemicals Trading FZ-LLC is a multinational organization that has been in industrial chemicals business for years. The head office is located in RAK-UAE with subsidiary operations at various locations, covering markets in Africa, Middle East, Subcontinent and South East Asia.
                <span className="pt-3 block">
                  Interpetro is a leading distributor of specialty chemicals for Coatings, Construction, Inks, Plastics, Fiberglass, Rubber, Aluminium surface treatment products, Pharmaceuticals, Agriculture, Water Treatment, Detergent, Polyurethane, Food and Allied industries.
                </span>
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9 }}
                className="flex items-center gap-4"
              >

              </motion.div>
            </motion.div>
          </div>

          {/* Decorative Star */}
          <motion.div
            initial={{ opacity: 0, rotate: -90 }}
            animate={{ opacity: 1, rotate: 0 }}
            transition={{ delay: 1, duration: 0.6 }}
            className="absolute top-12 right-12 text-emerald-400 hidden lg:block"
          >
            <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" />
            </svg>
          </motion.div>
        </div>
      </section>
    </>
  )
}

